import classNames from "classnames";
import type { IconType } from "@circle-react-shared/Icon";
import type { FieldAsItem } from "../ProfileFields/FormFields/CustomFieldsList";
import { HandleIcon } from "./HandleIcon";
import { UserActions } from "./UserActions";

export const styles = `
  group flex justify-between items-center
  px-3 w-full h-10 rounded-md border
  select-none border-primary bg-primary
  text-dark min-w-0`;

export interface SortableItemItem {
  icon?: IconType;
  label: string;
}

export interface DragEventListeners {
  onDragEnd: (event: React.DragEvent<HTMLElement>) => void;
  onDragStart: (event: React.DragEvent<HTMLElement>) => void;
}

export interface SortableItemProps {
  actions?: {
    tooltip: string;
    icon: IconType;
    onClick: (field: FieldAsItem) => void;
  }[];
  className?: string;
  dataTestId?: string;
  dragEventListeners: DragEventListeners;
  item: SortableItemItem;
  useDragHandle: boolean;
}

export const SortableItem = ({
  item,
  actions,
  useDragHandle,
  dragEventListeners,
  className,
  dataTestId,
}: SortableItemProps) => {
  const { icon, label } = item || {};

  return (
    <div
      className={classNames(
        styles,
        "hover:border-secondary transition-colors",
        className,
      )}
      data-testid={dataTestId}
    >
      <div className="flex items-center gap-2 truncate">
        {icon && (
          <HandleIcon
            icon={icon}
            {...(useDragHandle && {
              dragEventListeners,
            })}
          />
        )}
        <span className="truncate text-sm font-medium normal-case leading-5 tracking-tighter">
          {label}
        </span>
      </div>
      {actions && (
        <div className="flex gap-2">
          <UserActions item={item} actions={actions} />
        </div>
      )}
    </div>
  );
};
